'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToMoment(v) {
    if (!v) return v;
    return (0, _moment2.default)(new Date(v));
}

function momentToString(v, format) {
    if (!v) return v;
    return (0, _moment2.default)(v).format(format);
}

function getThisWeekRange() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

    return [(0, _moment2.default)().startOf('week').format(format), (0, _moment2.default)().endOf('week').format(format)];
}

function getLastWeekRange() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

    return [(0, _moment2.default)().subtract(1, 'week').startOf('week').format(format), (0, _moment2.default)().subtract(1, 'week').endOf('week').format(format)];
}

function getThisMonthRange() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

    return [(0, _moment2.default)().startOf('month').format(format), (0, _moment2.default)().endOf('month').format(format)];
}

function getLastMonthRange() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

    return [(0, _moment2.default)().subtract(1, 'month').startOf('month').format(format), (0, _moment2.default)().subtract(1, 'month').endOf('month').format(format)];
}

function getThisYearRange() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

    return [(0, _moment2.default)().startOf('year').format(format), (0, _moment2.default)().endOf('year').format(format)];
}

function getLastYearRange() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

    return [(0, _moment2.default)().subtract(1, 'year').startOf('year').format(format), (0, _moment2.default)().subtract(1, 'year').endOf('year').format(format)];
}

exports.default = {
    stringToMoment: stringToMoment,
    momentToString: momentToString,
    getThisWeekRange: getThisWeekRange,
    getLastWeekRange: getLastWeekRange,
    getThisMonthRange: getThisMonthRange,
    getLastMonthRange: getLastMonthRange,
    getThisYearRange: getThisYearRange,
    getLastYearRange: getLastYearRange
};
module.exports = exports['default'];